import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const NavContainer = styled.nav`
    background: white;
    padding: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #eee;
`;

const NavList = styled.ul`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 1rem;
`;

const NavItem = styled.li`
    a {
        text-decoration: none;
        color: #666;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        transition: all 0.2s;

        &:hover {
            background: #f5f5f5;
            color: #333;
        }

        &.active {
            background: #4CAF50;
            color: white;
        }
    }
`;

const AdminNav = () => {
    return (
        <NavContainer>
            <NavList>
                <NavItem>
                    <NavLink to="/admin" end>
                        Dashboard
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/admin/guides">
                        Guides
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/admin/coordinators">
                        Coordinators
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/admin/tours">
                        Tours
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/admin/bookings">
                        Bookings
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/admin/reviews">
                        Reviews
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/admin/invoices">
                        Invoices
                    </NavLink>
                </NavItem>
            </NavList>
        </NavContainer>
    );
};

export default AdminNav;
